module.exports = __webpack_public_path__ + "img/94.93a9019c.jpg";